// Componente Solicitudes.vue
<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="6">
              <b-button size="sm" variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i>Exportar</b-button>
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTableData"
                  :data="datasolicitudes"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  name: "Solicitudes",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    // title: { type: String },
    cod_asegurado: Number,
    participacion: Number,
    tpsolicitud: String,
    fedesde: Datepicker,
    fehasta: Datepicker,
    // timeOnSite: { type: Number, required: true }
  },

  data: function() {
    return {
      datasolicitudes:[],
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,

      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },

      nombreexcel: "Solicitudes",
      
      titles: [
        {
          prop: "nombrecliente",
          label: "Nombre Cliente",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "idnac",
          label: "Id. Nación",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "rutfic",
          label: "Rut Ficticio",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "pais",
          label: "País",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "direccion",
          label: "Dirección",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "ciudad",
          label: "Ciudad",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "tipo",
          label: "Tipo",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "montosolicitado",
          label: "Monto Solicitado",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "montoaprobado",
          label: "Monto Aprobado",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "documento",
          label: "Documento",
          align: "left",
          minwidth:'150'
        },      
        {
          prop: "analista",
          label: "Analista",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "plazo",
          label: "Plazo",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "fechasolicitud",
          label: "Fecha Solicitud",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "fecharesolucion",
          label: "Fecha Resolucion",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "estado",
          label: "Estado",
          align: "center",
          minwidth:'80'
        },      
        {
          prop: "comentariosext",
          label: "Comentarios Externos",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "comentariosint",
          label: "Comentarios Internos",
          align: "left",
          minwidth:'200'
        },      
        {
          prop: "solicitud",
          label: "Solicitud",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "comentariosext2",
          label: "Comentarios Externos ",
          align: "left",
          minwidth:'200'
        }
        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

    }
  },
  methods: {

    formatter(row, column) {
          if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
    },

    recuperar_solicitudes() {
      this.$Progress.start(); 
            
        return apiConsultaCliente
          .recuperar_solicitudes(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.cod_asegurado,
            this.tpsolicitud,
            this.fedesde, 
            this.fehasta
          )  
          .then(response => {
                
            response.data = this.keysMinuscula(response.data);
            this.datasolicitudes = response.data.res;
            // console.log(response.data.res);

            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= "Error";
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },

    descargarExcel: function () {
        var cuerpo = "";
        var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
        var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
        var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

        cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
        cuerpo += "\n";
        cuerpo += "<col width=80 style='width:60pt'>";
        cuerpo += "\n";

        
        ///COLUMNAS ESCRIBIR
        cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Nombre Cliente" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Id. Nación" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Rut Ficticio" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "País" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Dirección" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Ciudad" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Póliza" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Moneda" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Tipo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Monto Solicitado" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Monto Aprobado" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Documento" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Analista" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Plazo" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Fecha Solicitud" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Fecha Resolucion" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Estado" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Comentarios Externos" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Comentarios Internos" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Solicitud" + "</td>\n";
        cuerpo += "<td class=xl679618 style='border-left:none;" + xl679618 + "'>" + "Comentarios Externos" + "</td>\n";
        cuerpo += "</tr>\n";
        
        //Data bloque 1
        
        for (var key in this.datasolicitudes) {
          if(this.datasolicitudes[key]["nombrecliente"] === undefined){ 
            this.datasolicitudes[key]["nombrecliente"] = "";
          }
          if(this.datasolicitudes[key]["idnac"] === undefined){ 
            this.datasolicitudes[key]["idnac"] = "";
          }
          
          if(this.datasolicitudes[key]["rutfic"] == undefined){ 
            this.datasolicitudes[key]["rutfic"] = "";
          }
          if(this.datasolicitudes[key]["pais"] == undefined){ 
            this.datasolicitudes[key]["pais"] = "";
          }
          if(this.datasolicitudes[key]["direccion"] == undefined){ 
            this.datasolicitudes[key]["direccion"] = "";
          }
          if(this.datasolicitudes[key]["ciudad"] == undefined){ 
            this.datasolicitudes[key]["ciudad"] = "";
          }
          if(this.datasolicitudes[key]["poliza"] == undefined){ 
            this.datasolicitudes[key]["poliza"] = "";
          }
          if(this.datasolicitudes[key]["moneda"] == undefined){ 
            this.datasolicitudes[key]["moneda"] = "";
          }
          if(this.datasolicitudes[key]["tipo"] == undefined){ 
            this.datasolicitudes[key]["tipo"] = "";
          }
          if(this.datasolicitudes[key]["montosolicitado"] == undefined){ 
            this.datasolicitudes[key]["montosolicitado"] = "";
          }
          if(this.datasolicitudes[key]["documento"] == undefined){ 
            this.datasolicitudes[key]["documento"] = "";
          }
          if(this.datasolicitudes[key]["analista"] == undefined){ 
            this.datasolicitudes[key]["analista"] = "";
          }
          if(this.datasolicitudes[key]["plazo"] == undefined){ 
            this.datasolicitudes[key]["plazo"] = "";
          }
          if(this.datasolicitudes[key]["fechasolicitud"] == undefined){ 
            this.datasolicitudes[key]["fechasolicitud"] = "";
          }
          if(this.datasolicitudes[key]["fecharesolucion"] == undefined){ 
            this.datasolicitudes[key]["fecharesolucion"] = "";
          }
          if(this.datasolicitudes[key]["estado"] == undefined){ 
            this.datasolicitudes[key]["estado"] = "";
          }
          if(this.datasolicitudes[key]["comentariosext"] == undefined){ 
            this.datasolicitudes[key]["comentariosext"] = "";
          }
          if(this.datasolicitudes[key]["comentariosint"] == undefined){ 
            this.datasolicitudes[key]["comentariosint"] = "";
          }
          if(this.datasolicitudes[key]["solicitud"] == undefined){ 
            this.datasolicitudes[key]["solicitud"] = "";
          }
          if(this.datasolicitudes[key]["comentariosext2"] == undefined){ 
            this.datasolicitudes[key]["comentariosext2"] = "";
          }
          

          cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["nombrecliente"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["idnac"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["rutfic"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["pais"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["direccion"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["ciudad"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["poliza"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["moneda"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["tipo"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["montosolicitado"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["montoaprobado"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["documento"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["analista"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["plazo"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.datasolicitudes[key]["fechasolicitud"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.datasolicitudes[key]["fecharesolucion"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["estado"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["comentariosext"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["comentariosint"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["solicitud"] + "</td>\n";
          cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datasolicitudes[key]["comentariosext2"] + "</td>\n";
          cuerpo += "</tr>\n";
        }

        //Data bloque 1
        
        this.export(
          this.generaExcelV2(this.nombreexcel, cuerpo),
          this.nombreexcel
        );
      },

      export:async function(data, filename) {
        if(typeof this.beforeFinish === 'function')
          await this.beforeFinish();
        download(data, filename,  "application/vnd.ms-excel");
      },
    
    // recuperar_siniestro() {
    //   this.$Progress.start(); 
    //   return apiConsultaCliente
    //     .recuperar_siniestro(
    //       this.$session.get("mail"),
    //       this.$session.get("usuarioInterno"),
    //       this.cod_asegurado,
    //       this.participacion
    //       )  
    //       .then(response => {
    //         response.data = this.keysMinuscula(response.data);
    //         this.datasiniestro = response.data.res;
    //         this.$Progress.finish();
    //       })
    //       .catch(error => {
    //         this.mensaje= error;
    //         this.variant="warning";
    //         this.showAlert = true;
    //         this.$Progress.finish();
    //       });
    // },
        
  },
      
  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_solicitudes();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>